export default [
  {
    id: 1,
    slug: 'danone',
    title: 'Danone',
    src: '/img/relations/clients/danone.png',
    url: 'https://www.danone.nl'
  },
  {
    id: 2,
    slug: 'rfc',
    title: 'FrieslandCampina',
    src: '/img/relations/clients/rfc.png',
    url: 'https://www.frieslandcampina.nl'
  },
  {
    id: 3,
    slug: 'heineken',
    title: 'Heineken',
    src: '/img/relations/clients/heineken.png',
    url: 'https://www.heineken.nl'
  },
  {
    id: 4,
    slug: 'abnamro',
    title: 'ABN AMRO',
    src: '/img/relations/clients/abnamro.png',
    url: 'https://www.abnamro.nl'
  },
  {
    id: 5,
    slug: 'nestle',
    title: 'Atrium Innovations',
    src: '/img/relations/clients/nestle.png',
    url: 'https://www.nestle.nl'
  }
]
